<template>
    <Modal :mask-closable="true"  v-model="ModalShow" @on-cancel="close()" :closable="false" :width="width" :footer-hide="true" :scrollable="false" class-name="QHopen">
        <span class="closeBtn" @click="close()" :style="'top:'+closeBtnTop+'px'">{{closeBtnName}}</span>
        <iframe :src="url" frameborder="0" :style="'height:'+iframeHeight+';'">加载中...</iframe>
    </Modal>
</template>

<script>
export default {
    data() {
        return {
            ModalShow: true,
            iframeHeight: '90vh',
        };
    },
    props: {
        url:{
            type: String,
            default: "",
        },
        width:  {
            type: Number,
            default: 99,
        },
        closeBtnTop:  {
            type: Number,
            default: 8,
        },
        closeBtnName:  {
            type: String,
            default: "关闭全部",
        },
        height:  {
            type: Number,
            default: 99
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        if (this.height < 100|| this.height == 100) {
            this.iframeHeight = this.height + "vh";
        } else { 
            this.iframeHeight = this.height + "px";
        };
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>
<style>
.QHopen{z-index:100000 !important;display: flex;align-items: center;justify-content: center;}
.QHopen .ivu-modal{top:0 !important;}
.QHopen .ivu-modal-header{display:none;}
.QHopen .ivu-modal-body{padding:0 !important;overflow: hidden;}
.QHopen iframe{padding:0 !important;margin: 0 !important;width:100%;overflow-y:auto !important;display: block;}
.QHopen .ivu-modal-close{background:#ff9900;border-radius:300px;}
.QHopen .ivu-modal-close .ivu-icon{color:#fff !important;}
.QHopen .ivu-modal-content-drag{position:relative;width:100% !important;}
.QHopen .closeBtn{background:#ff9900;border-radius:300px;position:absolute;right:8px;top:8px;padding:10px;color:#fff;cursor: pointer;}
</style>